import React from "react"
import PropTypes from "prop-types"
import NewCost from "./NewCost"
import EditCost from "./EditCost"

const CostModal = ({
  open,
  onClose,
  onSave,
  costData = null,
  projectId,
  projectsHeaders = [],
}) => {
  const isEditing = !!costData

  if (isEditing) {
    return (
      <EditCost
        open={open}
        onClose={onClose}
        onSave={onSave}
        costData={costData}
        projectsHeaders={projectsHeaders}
      />
    )
  }

  return (
    <NewCost
      open={open}
      onClose={onClose}
      onSave={onSave}
      projectId={projectId}
    />
  )
}

CostModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  costData: PropTypes.object,
  projectId: PropTypes.string,
  projectsHeaders: PropTypes.array,
}

export default CostModal
